import { WritingAction } from "../features/writing/writingApiSlice";

export const NoTitleEntered = "No Title Entered";

export function draftTitle(title: string | undefined | null) {
	if (!title) return "";
	return title.trim().toLowerCase() !== NoTitleEntered.toLowerCase() ? title : "";
}

export const getActionUrl = (
	action?: WritingAction,
	id?: number,
	promptId?: number
): string | null => {
	switch (action) {
		case WritingAction.Organize:
			return `/writing/organize?draftId=${id}`;
		case WritingAction.Write:
			return `/writing/write?draftId=${id}`;
		case WritingAction.ScoreReport:
			return `/scoreReport?draftId=${id}`;
		case WritingAction.NotStarted:
			return `/writing?promptId=${promptId}`;
		case WritingAction.StartOrganizing:
			return `/writing/organizers?promptId=${id}`;
		case WritingAction.StartWriting:
		// fall through, special handling required
	}
	return null;
};

export function getStepName(essayStep: string, essayAction: WritingAction) {
	switch (essayAction) {
		case WritingAction.NotStarted:
			return "Not Started";
		case WritingAction.Organize:
			return "Step: Organizer";
		case WritingAction.ScoreReport:
			return `Step: ${essayStep} - Scored`;
		case WritingAction.Write:
			return `Step: ${essayStep} - In Progress`;
		default:
			return null;
	}
}
